import React, { forwardRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Alert, Image } from 'antd';
import { EyeFill, EarFill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LaboratorySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  var hltext = {
    color: '#9F403D',
    fontWeight: "bold"
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        style: {
          padding: "24px"
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "print-watermark",
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/emgl.png",
            alt: ""
          })
        }), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 6
          }), /*#__PURE__*/_jsx(ACol, {
            span: 16,
            offset: 2,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                padding: "14px",
                color: "#7C1F21",
                background: "#EFE1E1",
                clear: "both",
                borderRadius: "11px"
              },
              children: /*#__PURE__*/_jsxs(ARow, {
                children: [/*#__PURE__*/_jsx(ACol, {
                  span: 4,
                  children: /*#__PURE__*/_jsx(Image, {
                    src: "drawables/emgl.png",
                    preview: false,
                    width: "70px"
                  })
                }), /*#__PURE__*/_jsxs(ACol, {
                  span: 20,
                  children: [/*#__PURE__*/_jsx("h2", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RESULTATS DU LABORATOIRE"
                    })
                  }), /*#__PURE__*/_jsxs("span", {
                    children: ["N\xBA DOSSIER: ", candidat.candidate_code, " - PATIENT: ", candidat.name]
                  })]
                })]
              })
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            children: /*#__PURE__*/_jsx("h6", {
              style: {
                margin: "55px 0px"
              },
              children: candidat.laboratory_result && /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: candidat.laboratory_result.created_at,
                  format: "DD/MM/YYYY H:m"
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(ARow, {
          gutter: 8,
          children: /*#__PURE__*/_jsxs(ACol, {
            span: 24,
            children: [candidat.laboratory_result != null && candidat.laboratory_result.biochimie != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "BIOCHIMIE"
              }),
              column: 2,
              children: [candidat.laboratory_result.biochimie.glycemie && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.glycemie > "0.7" && candidat.laboratory_result.biochimie.glycemie <= "1.2" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "GLYCEMIE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.glycemie
                }), " (NORME: 0,7 - 1,2 g/l)"]
              }), candidat.laboratory_result.biochimie.uree && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.uree > "14" && candidat.laboratory_result.biochimie.uree <= "45" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "UREE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.uree
                }), " (NORME: 15 - 45 mg/dl)"]
              }), candidat.laboratory_result.biochimie.creatinemie && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.creatinemie > "0.5" && candidat.laboratory_result.biochimie.creatinemie <= "1.20" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CREATINEMIE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.creatinemie
                }), " (NORME: 0,60 - 1,20 mg/dl)"]
              }), candidat.laboratory_result.biochimie.cholesterol_t && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.cholesterol_t < "200" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHOLESTEROL TOTAL"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.cholesterol_t
                }), " (NORME: ", "<", " 200 mg/dl)"]
              }), candidat.laboratory_result.biochimie.cholesterol_hdl && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.cholesterol_hdl > "34" && candidat.laboratory_result.biochimie.cholesterol_hdl <= "65" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHOLESTEROL HDL"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.cholesterol_hdl
                }), " (NORME : 35 - 65 mg/dl)"]
              }), candidat.laboratory_result.biochimie.cholesterol_ldl && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.cholesterol_ldl <= "150" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHOLESTEROL LDL"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.cholesterol_ldl
                }), " (NORME: 150 mg/dl)"]
              }), candidat.laboratory_result.biochimie.triglyceride && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.triglyceride > "34" && candidat.laboratory_result.biochimie.triglyceride <= "200" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "TRIGLYCERIDE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.triglyceride
                }), " (NORME: 35 - 200 mg/dl)"]
              }), candidat.laboratory_result.biochimie.gamma_gt && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.gamma_gt <= "50" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "GAMMA GT"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.gamma_gt
                }), " (NORME: \u2264 50)"]
              }), candidat.laboratory_result.biochimie.got && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.got < "45" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "GOT"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.got
                }), " (NORME: ", "<", " 45 Ul/L)"]
              }), candidat.laboratory_result.biochimie.gpt && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.gpt < "45" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "GPT"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.biochimie.gpt
                }), " (NORME: ", "<", " 45 Ul/L)"]
              }), candidat.laboratory_result.biochimie.au && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.biochimie.au < "4.5" && candidat.laboratory_result.biochimie.au >= "9.1" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "ACIDE URIQUE"
                }),
                children: [candidat.laboratory_result.biochimie.au, " (NORME: = 4,5 - 9,1 mg/dl)"]
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.urine != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "URINE"
              }),
              columns: 3,
              children: [candidat.laboratory_result.urine.sang && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.sang.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "SANG"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.sang
                }), "(NORME: Absence)"]
              }), candidat.laboratory_result.urine.sucre && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.sucre.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "GLUCOSE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.sucre
                }), " (NORME: Absence)"]
              }), candidat.laboratory_result.urine.albumine && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.albumine.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "PROTEINE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.albumine
                }), " (NORME: Absence)"]
              }), candidat.laboratory_result.urine.cetonique && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.cetonique.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CORP CETONIQUE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.cetonique
                }), " (NORME: Absence)"]
              }), candidat.laboratory_result.urine.bilirubine && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.bilirubine.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "BILIRUBINE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.bilirubine
                }), " (NORME: Absence)"]
              }), candidat.laboratory_result.urine.urobilinogene && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.urobilinogene.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "UROBILINOGENE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.urobilinogene
                }), " (NORME: Absence)"]
              }), candidat.laboratory_result.urine.nitrites && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.nitrites.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "NITRITES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.nitrites
                }), " (NORME: Absence)"]
              }), candidat.laboratory_result.urine.leucocytes && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.leucocytes.toLowerCase().indexOf("abs") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "LEUCOCYTES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.leucocytes
                }), " (NORME: Absence)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.densite >= "1.020" && candidat.laboratory_result.urine.densite <= "1.020" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "DENSITE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.densite
                }), " (NORME: 1,010 - 1,020)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.urine.ph >= "5.4" && candidat.laboratory_result.urine.ph <= "7.2" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "PH"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.urine.ph
                }), " (NORME: 5,4 - 7,2)"]
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.hemato != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "HEMATOLOGIE"
              }),
              column: 2,
              children: [candidat.laboratory_result.hemato.gb && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.gb > "4.0" && candidat.laboratory_result.hemato.gb <= "10" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "LEUCOCYTES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.gb
                }), " (NORME: 4,0 - 10 x10^9/l)"]
              }), candidat.laboratory_result.hemato.granulocytes && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.granulocytes > "39" && candidat.laboratory_result.hemato.granulocytes <= "75" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "GRANULOCYTES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.granulocytes
                }), " (NORME: 40 - 75 %)"]
              }), candidat.laboratory_result.hemato.monocytes && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.monocytes > "1" && candidat.laboratory_result.hemato.monocytes <= "8" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "MONOCYTES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.monocytes
                }), " (NORME: 2-15 %)"]
              }), candidat.laboratory_result.hemato.lymphocytes && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.lymphocytes > "19" && candidat.laboratory_result.hemato.lymphocytes <= "40" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "LYMPHOCYTES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.lymphocytes
                }), " (NORME: 20 - 40 x10^9/l)"]
              }), candidat.laboratory_result.hemato.gr && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.gr > "3.5" && candidat.laboratory_result.hemato.gr <= "5.5" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "HEMATIES"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.gr
                }), " (NORME: 3,5 - 5,5 x10^12/l)"]
              }), candidat.laboratory_result.hemato.vgm && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.vgm > "80" && candidat.laboratory_result.hemato.vgm <= "95" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "VGM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.vgm
                }), " (NORME: 80 - 95 fl)"]
              }), candidat.laboratory_result.hemato.tcmh && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.tcmh > "27" && candidat.laboratory_result.hemato.tcmh <= "32" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "TCMH"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.tcmh
                }), " (NORME: 28 - 32 pg)"]
              }), candidat.laboratory_result.hemato.ccmh && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.ccmh > "29" && candidat.laboratory_result.hemato.ccmh <= "35" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CCMH"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.ccmh
                }), " (NORME: 30 - 35 g/dl)"]
              }), candidat.laboratory_result.hemato.hemoglobine && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.hemoglobine > "11" && candidat.laboratory_result.hemato.hemoglobine <= "17" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "HEMOGLOBINE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.hemoglobine
                }), " (NORME: 12 - 17 g/dl)"]
              }), candidat.laboratory_result.hemato.hematocrite && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.hematocrite > "39" && candidat.laboratory_result.hemato.hematocrite <= "52" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "HEMATOCRITE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.hematocrite
                }), " (NORME: 40 - 52 %)"]
              }), candidat.laboratory_result.hemato.plaquette && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemato.plaquette > "99" && candidat.laboratory_result.hemato.plaquette <= "300" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "PLAQUETTE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.plaquette
                }), " (NORME: 100 - 300 x10^9/l)"]
              }), candidat.laboratory_result.hemato.hba1c && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: {},
                label: /*#__PURE__*/_jsx("b", {
                  children: "HbA1c"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.hba1c && candidat.laboratory_result.hemato.hba1c
                }), " (NORME: ", "< 6.5%", ")"]
              }), candidat.laboratory_result.hemato.groupe && /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "GROUPE SANGUIN"
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.groupe
                })
              }), candidat.laboratory_result.hemato.rhesus && /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "FACTEUR RHESUS"
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemato.rhesus
                })
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.ionogramme != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "IONOGRAMME"
              }),
              column: 2,
              children: [candidat.laboratory_result.ionogramme.calcium && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.ionogramme.calcium > "8.4" && candidat.laboratory_result.ionogramme.calcium <= "10.2" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CALCIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.calcium
                }), " (NORME: 8,4 - 10,2 mg/l)"]
              }), candidat.laboratory_result.ionogramme.magnesium && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.ionogramme.magnesium > "1.8" && candidat.laboratory_result.ionogramme.magnesium <= "2.6" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "MAGNESIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.magnesium
                }), " (NORME: 1,8 - 2,6 mg/l)"]
              }), candidat.laboratory_result.ionogramme.chlore && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.ionogramme.chlore > "96" && candidat.laboratory_result.ionogramme.chlore <= "108" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CHLORE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.chlore
                }), " (NORME: 97 - 108 mmol/l)"]
              }), candidat.laboratory_result.ionogramme.potassium && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.ionogramme.potassium > "3.6" && candidat.laboratory_result.ionogramme.potassium <= "5.5" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "POTASSIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.potassium
                }), " (NORME: 3,6 - 5,5 mmol/l)"]
              }), candidat.laboratory_result.ionogramme.sodium && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.ionogramme.sodium > "134" && candidat.laboratory_result.ionogramme.sodium <= "150" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "SODIUM"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.ionogramme.sodium
                }), " (NORME: 135 - 150 mmol/l)"]
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.serologie != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "SEROLOGIE"
              }),
              column: 2,
              children: [candidat.laboratory_result.serologie.aghbs && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.serologie.aghbs.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "AgHBs"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.aghbs
                }), " (NORME: N\xE9gatif)"]
              }), candidat.laboratory_result.serologie.agp26 && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.serologie.agp26.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "AgP26"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.agp26
                }), " (NORME: N\xE9gatif)"]
              }), candidat.laboratory_result.serologie.crp && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.serologie.crp.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CRP"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.crp
                }), " (NORME: N\xE9gatif)"]
              }), candidat.laboratory_result.serologie.achcv && /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.serologie.achcv.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "AcHCV"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.achcv == 1 || candidat.laboratory_result.serologie.achcv == 0 ? /*#__PURE__*/_jsx("span", {
                    children: candidat.laboratory_result.serologie.achcv == 0 ? "NEGATIF" : "POSITIF"
                  }) : "--"
                }), " (NORME: N\xE9gatif)"]
              }), candidat.laboratory_result.serologie.widal_th && candidat.laboratory_result.serologie.widal_th != null && candidat.laboratory_result.serologie.widal_th != 'null' && /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Widal TH"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.widal_th == 1 || candidat.laboratory_result.serologie.widal_th == 0 ? /*#__PURE__*/_jsx("span", {
                    children: candidat.laboratory_result.serologie.widal_th == 0 ? "NEGATIF" : "POSITIF"
                  }) : "--"
                }), " (NORME: N\xE9gatif) ", candidat.laboratory_result.serologie.widal_th == 1 && candidat.laboratory_result.serologie.widal_comment_th]
              }), candidat.laboratory_result.serologie.widal_to && candidat.laboratory_result.serologie.widal_to != null && candidat.laboratory_result.serologie.widal_to != "null" && /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Widal TO"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.serologie.widal_to == 1 || candidat.laboratory_result.serologie.widal_to == 0 ? /*#__PURE__*/_jsx("span", {
                    children: candidat.laboratory_result.serologie.widal_to == 0 ? "NEGATIF" : "POSITIF"
                  }) : "--"
                }), " (NORME: N\xE9gatif) ", candidat.laboratory_result.serologie.widal_to == 1 && candidat.laboratory_result.serologie.widal_comment_to]
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.drug_test != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "ADDICTOLOGIE"
              }),
              columns: 3,
              children: [candidat.laboratory_result.drug_test.alcool && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.alcool.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "ALCOOL"
                }),
                children: candidat.laboratory_result.drug_test.alcool == 1 || candidat.laboratory_result.drug_test.alcool == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.alcool == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.amphetamine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.amphetamine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "AMPHETAMINES"
                }),
                children: candidat.laboratory_result.drug_test.amphetamine == 1 || candidat.laboratory_result.drug_test.amphetamine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.amphetamine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.benzodiazepine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.benzodiazepine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "BENZODIAZEPINES"
                }),
                children: candidat.laboratory_result.drug_test.benzodiazepine == 1 || candidat.laboratory_result.drug_test.benzodiazepine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.benzodiazepine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.cannabinoide && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.cannabinoide.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CANNABINOIDES"
                }),
                children: candidat.laboratory_result.drug_test.cannabinoide == 1 || candidat.laboratory_result.drug_test.cannabinoide == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.cannabinoide == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.opiace && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.opiace.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "OPIACES"
                }),
                children: candidat.laboratory_result.drug_test.opiace == 1 || candidat.laboratory_result.drug_test.opiace == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.opiace == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.cocaine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.cocaine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "COCAINE"
                }),
                children: candidat.laboratory_result.drug_test.cocaine == 1 || candidat.laboratory_result.drug_test.cocaine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.cocaine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.ketamine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.ketamine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "KETAMINE"
                }),
                children: candidat.laboratory_result.drug_test.ketamine == 1 || candidat.laboratory_result.drug_test.ketamine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.ketamine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.methamphetamine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.methamphetamine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "METHAMPHETAMINE"
                }),
                children: candidat.laboratory_result.drug_test.methamphetamine == 1 || candidat.laboratory_result.drug_test.methamphetamine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.methamphetamine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.barbiluriques && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.barbiluriques.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "BARBILURIQUES"
                }),
                children: candidat.laboratory_result.drug_test.barbiluriques == 1 || candidat.laboratory_result.drug_test.barbiluriques == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.barbiluriques == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.phenyclidine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.phenyclidine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "PHENYCLIDINE"
                }),
                children: candidat.laboratory_result.drug_test.phenyclidine == 1 || candidat.laboratory_result.drug_test.phenyclidine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.phenyclidine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              }), candidat.laboratory_result.drug_test.morphine && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.drug_test.morphine.toLowerCase().indexOf("pos") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "MORPHINE"
                }),
                children: candidat.laboratory_result.drug_test.morphine == 1 || candidat.laboratory_result.drug_test.morphine == 0 ? /*#__PURE__*/_jsx("span", {
                  children: candidat.laboratory_result.drug_test.morphine == 0 ? "NEGATIF" : "POSITIF"
                }) : "--"
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.parasitologie != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "PARASITOLOGIE"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "ASPECT"
                }),
                children: candidat.laboratory_result.parasitologie.aspect
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "COULEUR"
                }),
                children: candidat.laboratory_result.parasitologie.color
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "RESULTAT"
                }),
                children: candidat.laboratory_result.parasitologie.result
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.blood_parasitology != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "PARASITOLOGIE DU SANG"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Go\xFBtte \xE9paisse"
                }),
                children: candidat.laboratory_result.blood_parasitology.ge == 0 ? "NEGATIVE" : "POSITIVE"
              }), candidat.laboratory_result.blood_parasitology.ge == 1 && /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Densit\xE9 Parasitaire"
                }),
                children: [candidat.laboratory_result.blood_parasitology.dp, " Trophozo\xEFtes/\xB5L"]
              }), candidat.laboratory_result.blood_parasitology.ge == 1 && /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "TDR"
                }),
                children: candidat.laboratory_result.blood_parasitology.tdr
              }), candidat.laboratory_result.blood_parasitology.ge == 1 && /*#__PURE__*/_jsxs(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Interpretation"
                }),
                children: [candidat.laboratory_result.blood_parasitology.dp < 1000 && "Densité parasitaire très faible", candidat.laboratory_result.blood_parasitology.dp > 1000 && candidat.laboratory_result.blood_parasitology.dp <= 10000 && "Densité parasitaire faible", candidat.laboratory_result.blood_parasitology.dp >= 1001 && candidat.laboratory_result.blood_parasitology.dp <= 50000 && "Densité parasitaire moyenne"]
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.coproculture != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "COPROCULTURE"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Aspect"
                }),
                children: candidat.laboratory_result.coproculture.aspect
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Leucocytes"
                }),
                children: candidat.laboratory_result.coproculture.leucocytes
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Hematies"
                }),
                children: candidat.laboratory_result.coproculture.hematies
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Levures"
                }),
                children: candidat.laboratory_result.coproculture.levures
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Parasites"
                }),
                children: candidat.laboratory_result.coproculture.parasites
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Autres"
                }),
                children: candidat.laboratory_result.coproculture.others
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Culture"
                }),
                children: candidat.laboratory_result.coproculture.culture
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Conclusion"
                }),
                children: candidat.laboratory_result.coproculture.conclusion
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.hemostase != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "HEMOSTASE"
              }),
              columns: 3,
              children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemostase.prothrombine > "69" && candidat.laboratory_result.hemostase.prothrombine <= "100" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "TAUX DE PROTHROMBINE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemostase.prothrombine
                }), " (Ref. 70-100)"]
              }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                contentStyle: candidat.laboratory_result.hemostase.thromboplastine > "24" && candidat.laboratory_result.hemostase.thromboplastine <= "43" ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "TEMPS PARTIEL DE THROMBOPLASTINE ACTIVE"
                }),
                children: [/*#__PURE__*/_jsx("b", {
                  children: candidat.laboratory_result.hemostase.thromboplastine
                }), " (Ref. 25-43)"]
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "INR"
                }),
                children: candidat.laboratory_result.hemostase.inr
              })]
            }), candidat.laboratory_result != null && candidat.laboratory_result.ecbu != null && /*#__PURE__*/_jsxs(Descriptions, {
              style: {
                marginBottom: "18px"
              },
              bordered: true,
              size: "small",
              title: /*#__PURE__*/_jsx("b", {
                children: "ECBU"
              }),
              columns: 3,
              children: [candidat.laboratory_result.ecbu.aspect && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: !candidat.laboratory_result.ecbu.aspect.toLowerCase().indexOf("norm") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "ASPECT"
                }),
                children: candidat.laboratory_result.ecbu.aspect
              }), candidat.laboratory_result.ecbu.couleur && /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "COULEUR"
                }),
                children: candidat.laboratory_result.ecbu.couleur
              }), candidat.laboratory_result.ecbu.leucocytes && /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "LEUCOCYTES"
                }),
                children: candidat.laboratory_result.ecbu.leucocytes
              }), !candidat.laboratory_result.ecbu.hematies && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: !candidat.laboratory_result.ecbu.hematies.toLowerCase().indexOf("norm") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "HEMATIES"
                }),
                children: candidat.laboratory_result.ecbu.hematies
              }), candidat.laboratory_result.ecbu.epitheliales && /*#__PURE__*/_jsx(Descriptions.Item, {
                contentStyle: !candidat.laboratory_result.ecbu.epitheliales.toLowerCase().indexOf("norm") > -1 ? {} : hltext,
                label: /*#__PURE__*/_jsx("b", {
                  children: "CELLULES EPITHELIALES"
                }),
                children: candidat.laboratory_result.ecbu.epitheliales
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "PARASITES"
                }),
                children: candidat.laboratory_result.ecbu.parasites
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "LEVURE"
                }),
                children: candidat.laboratory_result.ecbu.levure
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "AUTRES"
                }),
                children: candidat.laboratory_result.ecbu.autres != "undefined" && candidat.laboratory_result.ecbu.autres
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Responsable du Laboratoire"
              })
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          }), /*#__PURE__*/_jsx(ACol, {
            span: 8
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
  });
});
export default LaboratorySheet;